import Emitter from "./Emitter";

export default class ListenersReady extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        this.emitParent({wpgaction: "listenersReady.parent"});
        this.emitTop({wpgaction: "listenersReady"});
        this.emitiOS({wpgaction: "listenersReady"});
    }
}
